import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import brandPortalOrdersbrandOrderTokenOrderInvoice from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/order-invoice";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var InvoiceDetailsIA = function InvoiceDetailsIA(_ref) {
  var isAusOrEurBrand = _ref.isAusOrEurBrand,
    brandOrderToken = _ref.brandOrderToken;
  if (isAusOrEurBrand && brandOrderToken) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "+HEyjw",
      defaultMessage: [{
        "type": 0,
        "value": "Nous vous fournirons des factures pour toutes les commandes que vous recevrez sur Faire. Les factures sont finalisées une fois la commande expédiée. Pour retrouver la facture d'une commande, rendez-vous dans "
      }, {
        "children": [{
          "type": 0,
          "value": "Commandes"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": ", accédez à la "
      }, {
        "children": [{
          "type": 0,
          "value": "page Détails de la commande"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": "concernée et sélectionnez Facture de la commande."
      }],
      values: {
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          return _OrderLinkFormatting(chunks, brandOrderToken);
        },
        InvoiceLinkFormatting: function InvoiceLinkFormatting(chunks) {
          return invoiceLinkFormatting(chunks, brandOrderToken);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "RFmrRL",
      defaultMessage: [{
        "type": 0,
        "value": "Vous ne recevrez pas de factures de commande. Cependant, vous pouvez consulter le récapitulatif de votre paiement sur la "
      }, {
        "children": [{
          "type": 0,
          "value": "page Détails de la commande"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": " et générer votre propre facture en fonction des informations fournies. Si vous choisissez de créer votre propre facture, sachez qu'elle est réservée à votre usage interne et ne doit pas être envoyée à Faire ou à un commerçant."
      }],
      values: {
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          return _OrderLinkFormatting(chunks, brandOrderToken);
        }
      }
    })));
  }
};
var _OrderLinkFormatting = function _OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Bold, null, chunks);
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};
var invoiceLinkFormatting = function invoiceLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenOrderInvoice(brandOrderToken),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};